module.exports = __webpack_public_path__ + "static/img/C.0193a88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ssxxg/C.png
// module id = MUqx
// module chunks = 0